/**
 * Motor Vital cart page — live quantity updates via the Cart AJAX API.
 *
 * Every change goes to /cart/change.js together with the page section id, Shopify
 * re-renders the section server-side and we swap the markup in. Line prices,
 * savings, item count, totals and the empty state therefore always match the
 * cart exactly; the <form> stays as the no-JS fallback.
 */
( function () {
	'use strict';

	var root = document.querySelector( '[data-mv-cart-page]' );
	if ( ! root ) {
		return;
	}

	var sectionId = root.getAttribute( 'data-section-id' );
	var busy = false;
	var pendingTimer = null;

	root.classList.add( 'js-enabled' );

	function updateBadges( cart ) {
		var count = Number( cart.item_count || 0 );
		document.querySelectorAll( '[data-mv-cart-count]' ).forEach( function ( badge ) {
			badge.textContent = String( count );
			badge.classList.toggle( 'is-empty', count === 0 );
		} );
		document.querySelectorAll( '[data-mv-cart-open]' ).forEach( function ( trigger ) {
			trigger.setAttribute( 'aria-label', count > 0 ? 'Warenkorb, ' + count + ' Artikel' : 'Warenkorb' );
		} );
		document.dispatchEvent( new CustomEvent( 'mv:cart-updated', { detail: { cart: cart } } ) );
	}

	function showNotice( message ) {
		var existing = root.querySelector( '.mv-cart-page__notice' );
		if ( existing ) {
			existing.remove();
		}
		var notice = document.createElement( 'p' );
		notice.className = 'mv-cart-page__notice';
		notice.setAttribute( 'role', 'alert' );
		notice.textContent = message;
		var head = root.querySelector( '.mv-cart-page__head' );
		if ( head ) {
			head.insertAdjacentElement( 'afterend', notice );
		}
	}

	function swapSection( html ) {
		var doc = new DOMParser().parseFromString( html, 'text/html' );
		var fresh = doc.querySelector( '[data-mv-cart-page]' );
		if ( ! fresh ) {
			window.location.reload();
			return;
		}
		root.innerHTML = fresh.innerHTML;
		root.classList.remove( 'is-updating' );
	}

	function change( line, quantity, focusSelector ) {
		if ( busy ) {
			return;
		}
		busy = true;
		root.classList.add( 'is-updating' );
		var item = root.querySelector( '[data-mv-cart-line="' + line + '"]' );
		if ( item ) {
			item.classList.add( 'is-updating' );
		}

		fetch( '/cart/change.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: JSON.stringify( { line: line, quantity: quantity, sections: sectionId } ),
		} )
			.then( function ( response ) {
				if ( ! response.ok ) {
					throw new Error( 'cart/change ' + response.status );
				}
				return response.json();
			} )
			.then( function ( cart ) {
				var html = cart.sections && cart.sections[ sectionId ];
				if ( html ) {
					swapSection( html );
				} else {
					window.location.reload();
					return;
				}
				updateBadges( cart );
				if ( focusSelector ) {
					var target = root.querySelector( '[data-mv-cart-line="' + line + '"] ' + focusSelector );
					if ( target && ! target.disabled ) {
						target.focus( { preventScroll: true } );
					}
				}
			} )
			.catch( function () {
				root.classList.remove( 'is-updating' );
				showNotice( 'Die Menge konnte gerade nicht aktualisiert werden. Bitte versuchen Sie es erneut.' );
			} )
			.then( function () {
				busy = false;
			} );
	}

	function lineOf( element ) {
		var item = element.closest( '[data-mv-cart-line]' );
		return item ? Number( item.getAttribute( 'data-mv-cart-line' ) ) : null;
	}

	function currentQuantity( element ) {
		var item = element.closest( '[data-mv-cart-line]' );
		var input = item && item.querySelector( '[data-mv-cart-page-qty]' );
		return input ? Number( input.value || 0 ) : 0;
	}

	root.addEventListener( 'click', function ( event ) {
		var dec = event.target.closest( '[data-mv-cart-page-dec]' );
		var inc = event.target.closest( '[data-mv-cart-page-inc]' );
		var remove = event.target.closest( '[data-mv-cart-page-remove]' );

		if ( dec || inc ) {
			event.preventDefault();
			var button = dec || inc;
			var line = lineOf( button );
			if ( line === null ) {
				return;
			}
			var quantity = Math.max( 0, currentQuantity( button ) + ( inc ? 1 : -1 ) );
			change( line, quantity, inc ? '[data-mv-cart-page-inc]' : '[data-mv-cart-page-dec]' );
			return;
		}

		if ( remove ) {
			event.preventDefault();
			var removeLine = lineOf( remove );
			if ( removeLine !== null ) {
				change( removeLine, 0 );
			}
		}
	} );

	/* Typed quantities: commit on Enter or after a short pause. */
	root.addEventListener( 'input', function ( event ) {
		var input = event.target.closest( '[data-mv-cart-page-qty]' );
		if ( ! input ) {
			return;
		}
		window.clearTimeout( pendingTimer );
		pendingTimer = window.setTimeout( function () {
			var line = lineOf( input );
			var quantity = Math.max( 0, Math.min( 999, Number( input.value || 0 ) ) );
			if ( line !== null && input.value !== '' ) {
				change( line, quantity, '[data-mv-cart-page-qty]' );
			}
		}, 650 );
	} );

	root.addEventListener( 'keydown', function ( event ) {
		var input = event.target.closest( '[data-mv-cart-page-qty]' );
		if ( ! input || event.key !== 'Enter' ) {
			return;
		}
		event.preventDefault();
		window.clearTimeout( pendingTimer );
		var line = lineOf( input );
		if ( line !== null ) {
			change( line, Math.max( 0, Math.min( 999, Number( input.value || 0 ) ) ), '[data-mv-cart-page-qty]' );
		}
	} );
} )();
